var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { CircleIcon } from './circle-icon';
export var PeopleCircleIcon = function PeopleCircleIcon(props) {
  return React.createElement(CircleIcon, __assign({}, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M24,5c10.5,0,19,8.5,19,19s-8.5,19-19,19S5,34.5,5,24S13.5,5,24,5 M24,1C11.3,1,1,11.3,1,24s10.3,23,23,23s23-10.3,23-23\n      S36.7,1,24,1L24,1z"
  }), React.createElement("g", null, React.createElement("path", {
    d: "M33,22c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4S30.8,22,33,22z M33,16c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S31.9,16,33,16\n        z"
  }), React.createElement("path", {
    d: "M15,22c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4S12.8,22,15,22z M15,16c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S13.9,16,15,16\n        z"
  }), React.createElement("path", {
    d: "M24,26c2.2,0,4-1.8,4-4s-1.8-4-4-4c-2.2,0-4,1.8-4,4S21.8,26,24,26z M24,20c1.1,0,2,0.9,2,2s-0.9,2-2,2c-1.1,0-2-0.9-2-2\n        S22.9,20,24,20z"
  }), React.createElement("path", {
    d: "M33,23c-2.9,0-5.4,2.1-5.9,4.9c-0.9-0.6-2-0.9-3.1-0.9s-2.2,0.3-3.1,0.9c-0.5-2.8-3-4.9-5.9-4.9c-3.3,0-6,2.7-6,6h4\n        c0-1.1,0.9-2,2-2s2,0.9,2,2h2.5c-1,1.1-1.5,2.5-1.5,4h4c0-1.1,0.9-2,2-2s2,0.9,2,2h4c0-1.5-0.6-2.9-1.5-4H31c0-1.1,0.9-2,2-2\n        s2,0.9,2,2h4C39,25.7,36.3,23,33,23z"
  })));
};